// @ts-ignore
import * as queryString from 'query-string';

class RouteParamsService {
    public getQueryParameters() : queryString.ParsedQuery{
        const params = queryString.parse(window.location.search)
        return params;
    }
}

export default new RouteParamsService();